module.exports = __webpack_public_path__ + "static/img/11.7804191.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/11.png
// module id = XNX/
// module chunks = 0